import { ShieldCheck, Tag, Truck, Headphones, LifeBuoy } from "lucide-react";

const POINTS = [
  { icon: <ShieldCheck size={22} />, title: "Quality Tested Parts", sub: "All parts are inspected & quality assured.", testid: "why-quality" },
  { icon: <Tag size={22} />,          title: "Competitive Prices",   sub: "Best prices for quality parts & services.",  testid: "why-price" },
  { icon: <Truck size={22} />,        title: "Fast Delivery",        sub: "Quick nationwide delivery across the UK.",   testid: "why-delivery" },
  { icon: <Headphones size={22} />,   title: "Professional Support", sub: "Our team is here to help you.",              testid: "why-support" },
  { icon: <LifeBuoy size={22} />,     title: "Trusted Recovery",     sub: "Reliable & quick vehicle recovery, anytime.", testid: "why-recovery" },
];

/**
 * "Why Choose Us" — 5-point value strip on a bright background, red circular
 * icons, per the reference mockup.
 */
const HomeWhyChoose = () => (
  <section className="py-20" data-testid="home-why-choose">
    <div className="vd-container">
      <div className="text-center mb-12">
        <h2 className="vd-why-heading">
          WHY CHOOSE <span className="vd-red">VALUEDRIVE AUTO SOLUTIONS?</span>
        </h2>
        <span className="vd-red-underline" aria-hidden="true" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
        {POINTS.map((p) => (
          <div key={p.title} className="text-center px-2" data-testid={p.testid}>
            <span className="vd-why-icon">{p.icon}</span>
            <div className="vd-heading font-extrabold mb-1.5 mt-4 text-[14px] tracking-wide">{p.title}</div>
            <p className="vd-muted text-[13px] leading-snug">{p.sub}</p>
          </div>
        ))}
      </div>
    </div>

    <style>{`
      .vd-why-heading { font-size: clamp(26px, 3.6vw, 38px); font-weight: 900; letter-spacing: 0.04em; margin: 0; }
      .vd-why-heading .vd-red { color: var(--primary-red); }
      .vd-why-icon {
        display: inline-flex; align-items: center; justify-content: center;
        width: 60px; height: 60px; border-radius: 999px;
        border: 2px solid var(--primary-red); color: var(--primary-red);
      }
    `}</style>
  </section>
);

export default HomeWhyChoose;
